export function localFixtureHost(hostname: string): boolean {
  return __MZN_LOCAL_FIXTURES__ && ["localhost", "127.0.0.1", "[::1]"].includes(hostname);
}
